export default "__VITE_ASSET__cn30Y1r4__"